<template>
<v-card :class="['result mx-auto', item.stop_sell ? 'inactive' : 'active' ]" max-width="400" :ripple="false" @mouseover="hover=true" @mouseleave="hover=false" height="100%">

    <v-card-title class="pb-1">
        <span>
            <span>{{item.name}}</span>
            <span class="overline font-weight-medium text-center">({{item.id}})</span>
        </span>
        <v-icon class="pa-1 icon-editv3" size="24" color="#5A8DEE" v-show="hover" @click="emitClick()">edit</v-icon>
    </v-card-title>

    <v-card-text class="text--primary">
        <v-chip class="ma-1" label :color="item.net_prices?'orange':'blue'" text-color="white">
            <span v-if="item.net_prices">
                {{ $t('rate_plan.card.price.net') }}
            </span>
            <span v-else>
                {{ $t('rate_plan.card.price.gross') }}
            </span>
        </v-chip>

        <div class="regular pt-1">
            Tip de masa: <span class="font-weight-bold">{{ $t('meal_type.' + item.meal_type ) }}</span>
        </div>

        <div class="regular">
            Camere asociate
        </div>
        <v-row class="mx-0" aling="center">
            <template v-if="!item.room_types.length">
                <span class="faded orange--text px-3">
                    Nu aveti nici o camera asociata cu acest plan
                </span>
            </template>
            <template v-else-if="item.room_types.length<3">
                <v-chip class="cursor-pointer ma-1" v-for="(room_type, index) in item.room_types" :key="index" small @click="editRoomType(room_type.id)">
                    <span class="regular" @click="editRoomType(room_type.id)" style="z-index:500">
                        <template v-if="room_type.name">
                            {{room_type.name}}
                        </template>
                        <template v-else>
                            {{ $t('room_type_slug.' + room_type.slug ) }}
                        </template>
                    </span>
                    <span class="ml-2 faded">{{room_type.id}}</span>
                </v-chip>
            </template>
            <template v-else>
                <v-chip class="cursor-pointer ma-1" small @click="editRoomType(item.room_types[0].id)">
                    <span class="regular" @click="editRoomType(room_type.id)" style="z-index:500">
                        <template v-if="item.room_types[0].name">
                            {{ item.room_types[0].name}}
                        </template>
                        <template v-else>
                            {{ $t('room_type_slug.' + item.room_types[0].slug ) }}
                        </template>
                    </span>
                    <span class="ml-2 faded">{{item.room_types[0].id}}</span>
                </v-chip>
                <v-chip class="cursor-pointer ma-1" small @click="editRoomType(item.room_types[1].id)">
                    <span class="regular" @click="editRoomType(room_type.id)" style="z-index:500">
                        <template v-if="item.room_types[1].name">
                            {{ item.room_types[1].name}}
                        </template>
                        <template v-else>
                            {{ $t('room_type_slug.' + item.room_types[1].slug ) }}
                        </template>
                    </span>
                    <span class="ml-2 faded">{{item.room_types[1].id}}</span>
                </v-chip>

                <span class="faded px-1" style="align-self: center">+ alte {{item.room_types.length-2}} camere</span>
            </template>
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
export default {
    name: `rate-plan-card`,

    props: {
        item: Object,
    },
    data() {
        return {
            hover: false,
        };
    },

    methods: {
        editRoomType(room_id) {
            let slug = this.$route.params.hotel_slug;
            this.$router.push({
                path: '/' + slug + '/room-types/' + room_id
            });
        },
        emitClick() {
            this.$emit('edit');
        },
    },
}
</script>
<style lang="stylus">
.icon-editv3
    background-color:  rgba(90,141,238, 0.2)
    border-radius: 50%
    position: absolute
    top: 15px
    right: 15px
</style>
